import handbook from '@app/core/services/handbook.js';

export default {
    methods: {
        $handbook(key) {
            return handbook().get(key);
        },
    },
}